import { inject, PLATFORM_ID, TransferState, provideAppInitializer, EnvironmentProviders } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { cargarNgStateSiNecesario } from '@core/utils/cargar-ng-state-pagina.util';

const RUTAS_PRECOMPILADAS = [
  'bienvenida',
  'datos-basicos',
  'datos-economicos-seccion-1',
  'datos-economicos-seccion-2',
  'terminos-condiciones',
  'pre-biometrica',
  'confirmar-datos',
  'confirmacion-cuenta',
  'firma-electronica',
] as const;

export function proveedorPrecargarEstadoInicial(): EnvironmentProviders {
  return provideAppInitializer(async () => {
    const platformId = inject(PLATFORM_ID);
    if (!isPlatformBrowser(platformId)) {
      return;
    }

    const transferState = inject(TransferState);

    await Promise.allSettled(RUTAS_PRECOMPILADAS.map((ruta) => cargarNgStateSiNecesario(ruta, transferState)));
  });
}
